module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.currForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": !_vm.edit,
      "placeholder": "最多20个字"
    },
    model: {
      value: (_vm.currForm.name),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "name", $$v)
      },
      expression: "currForm.name"
    }
  }), _vm._v(" "), (_vm.currForm.id) ? _c('span', [_vm._v("当前装配人数：" + _vm._s(_vm.currForm.countUsed))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "底部Tab"
    }
  }, [_c('div', {
    staticClass: "bezel"
  }, [_vm._l((_vm.currForm.homeIcon), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bezel-box"
    }, [_c('el-button', {
      staticClass: "bezel-close",
      attrs: {
        "icon": "circle-close",
        "disabled": !_vm.edit
      },
      on: {
        "click": function($event) {
          return _vm.tapDelete(index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "464px"
      },
      attrs: {
        "placeholder": "请输入Code",
        "disabled": !_vm.edit
      },
      model: {
        value: (item.moduleId),
        callback: function($$v) {
          _vm.$set(item, "moduleId", $$v)
        },
        expression: "item.moduleId"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bezel-list"
    }, [_c('div', {
      staticClass: "bezel-item"
    }, [(!item.iconNormal) ? _c('span', {
      staticClass: "bezel-label"
    }, [_vm._v("未选中状态")]) : _vm._e(), _vm._v(" "), _c('SUpload', {
      attrs: {
        "accept": "image/*",
        "type": "drag",
        "size": 50,
        "disabled": !_vm.edit,
        "show-file-list": false
      },
      model: {
        value: (item.iconNormal),
        callback: function($$v) {
          _vm.$set(item, "iconNormal", $$v)
        },
        expression: "item.iconNormal"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bezel-item"
    }, [(!item.iconSelected) ? _c('span', {
      staticClass: "bezel-label"
    }, [_vm._v("已选中状态")]) : _vm._e(), _vm._v(" "), _c('SUpload', {
      attrs: {
        "accept": "image/*",
        "type": "drag",
        "size": 50,
        "disabled": !_vm.edit,
        "show-file-list": false
      },
      model: {
        value: (item.iconSelected),
        callback: function($$v) {
          _vm.$set(item, "iconSelected", $$v)
        },
        expression: "item.iconSelected"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bezel-item"
    }, [(!item.backToTop) ? _c('span', {
      staticClass: "bezel-label"
    }, [_vm._v("回到顶部按钮")]) : _vm._e(), _vm._v(" "), _c('SUpload', {
      attrs: {
        "accept": "image/*",
        "type": "drag",
        "size": 50,
        "disabled": !_vm.edit,
        "show-file-list": false
      },
      model: {
        value: (item.backToTop),
        callback: function($$v) {
          _vm.$set(item, "backToTop", $$v)
        },
        expression: "item.backToTop"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "bezel-tips"
    }, [_vm._v("尺寸要求88*89，最大50KB, 优先SVG其次png")])], 1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.edit
    },
    on: {
      "click": _vm.tapAdd
    }
  }, [_vm._v("添加")])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图"
    }
  }, [_c('div', {
    staticClass: "flex-row",
    staticStyle: {
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticClass: "background-img-content"
  }, [_c('div', [_vm._v("tab栏底部背景")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 200,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.homeIcon[0].backgroundImage),
      callback: function($$v) {
        _vm.$set(_vm.currForm.homeIcon[0], "backgroundImage", $$v)
      },
      expression: "currForm.homeIcon[0].backgroundImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸要求402*49，最大200KB，优先webp次选png")])], 1), _vm._v(" "), _c('div', {
    staticClass: "background-img-content"
  }, [_c('div', [_vm._v("首页背景")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 200,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.homeIcon[0].homeBackgroundImage),
      callback: function($$v) {
        _vm.$set(_vm.currForm.homeIcon[0], "homeBackgroundImage", $$v)
      },
      expression: "currForm.homeIcon[0].homeBackgroundImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议402*177，最大200KB，优先webp次选png")])], 1), _vm._v(" "), _c('div', {
    staticClass: "background-img-content"
  }, [_c('div', [_vm._v("我的页面背景")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 200,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.homeIcon[0].myBackgroundImage),
      callback: function($$v) {
        _vm.$set(_vm.currForm.homeIcon[0], "myBackgroundImage", $$v)
      },
      expression: "currForm.homeIcon[0].myBackgroundImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议402*189，最大200KB，优先webp次选png")])], 1), _vm._v(" "), _c('div', {
    staticClass: "background-img-content"
  }, [_c('div', [_vm._v("广场页背景")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 200,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.homeIcon[0].squareBackgroundUrl),
      callback: function($$v) {
        _vm.$set(_vm.currForm.homeIcon[0], "squareBackgroundUrl", $$v)
      },
      expression: "currForm.homeIcon[0].squareBackgroundUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议402*221，最大200KB，优先webp次选png")])], 1), _vm._v(" "), _c('div', {
    staticClass: "background-img-content"
  }, [_c('div', [_vm._v("运动页背景")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.homeIcon[0].sportBackgroundUrl),
      callback: function($$v) {
        _vm.$set(_vm.currForm.homeIcon[0], "sportBackgroundUrl", $$v)
      },
      expression: "currForm.homeIcon[0].sportBackgroundUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("支持jpg、png、gif")])], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.currForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "sort", $$v)
      },
      expression: "currForm.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("数字越小越靠前，数字一致时优先展示最近创建的")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "皮肤效果",
      "prop": "effectImage"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 300,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.effectImage),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "effectImage", $$v)
      },
      expression: "currForm.effectImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("尺寸建议300 x 280，大小不超过300")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拥有学生"
    }
  }, [_c('SelectStudent', {
    ref: "SelectStudentRef",
    attrs: {
      "disabled": _vm.edit,
      "selectVal": _vm.currForm.useType,
      "privileges": _vm.currForm.privilegeRole
    },
    on: {
      "update:selectVal": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      },
      "update:select-val": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.superscript),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "superscript", $$v)
      },
      expression: "currForm.superscript"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议40*40，最大50KB，优先SVG其次png")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45f0ea34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/BottomButton.vue
// module id = 1009
// module chunks = 0